const USD_FORMATTER = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  
  export const formatCurrency = (value: number): string => USD_FORMATTER.format(value);